import { ITreeNode } from "../../../../../libs/ts/WorkflowTree/Nodes/ITreeNode";
import { InfoView } from "../elements/nodeViews/InfoView";
import { JbpTreeNodeData } from "../treeExtensions/JbpTreeNodeData";
import { IJbpChildNodeRelationship } from "../treeExtensions/IJbpChildNodeRelationship";
import { IViewFactory } from "./IViewFactory";

export class InfoFactory extends IViewFactory {
    public override MakeView(node: ITreeNode<JbpTreeNodeData, IJbpChildNodeRelationship>, mpan: string, _serviceLine: string): JSX.Element {
        return <InfoView key={node.Identifier()} node={node} mpan={mpan} />;
    }
}
